import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddImmobilizationToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/immobilization/store/immobilization.actions'
import { addImmobilizationItem } from '../../timeline/store/timeline.actions'
import { ImmobilizationConstants } from '../../procedures/immobilization/store/immobilization.constants'

export function* saveImmobilizationQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addImmobilizationToTimeline } = quickActionsObject
  if (addImmobilizationToTimeline) {
    yield put(addImmobilizationItem())
    yield put(setAddImmobilizationToTimeline(false))
    yield put(resetState())
  }
}

export function* saveImmobilizationQuickActionTimeLineRowSaga() {
  yield takeLatest([ImmobilizationConstants.SET_ADD_TO_TIMELINE], saveImmobilizationQuickActionTimeLineRow)
}
